import React from 'react';
import logo from "../../assets/logo/logo-icon.png";

function LogoAnimation({ percentage = 100 }) {
  // Base sizes
  const baseWidth = 7; // Base width in rems for the logo
  const baseTextSize = 3.25; // Base text size in rems
  const baseParagraphSize = 1.53; // Base paragraph size in rems
  const baseLineHeight = 1; // Base line-height
  const baseMarginBottom = -0.625;

  // Calculate sizes based on percentage
  const width = `${(baseWidth * percentage) / 100}rem`;
  const textSize = `${(baseTextSize * percentage) / 100}rem`;
  const paragraphSize = `${(baseParagraphSize * percentage) / 100}rem`;
  const marginBottom = `${(baseMarginBottom * percentage) / 100}rem`; // Line height doesn't need unit

  return (
    <>
      <div className="flex justify-start items-end me-0">
        <img
          src={logo}
          alt="Logo"
          className="object-contain"
          style={{ width }} // Apply dynamic width
        />
        <div
          className={`flex overflow-hidden text-white ms-1`}
          style={{ fontSize: textSize, lineHeight: textSize, marginBottom: marginBottom }} // Apply dynamic font size and line height
        >
          <span className="letter panoragraf-regular font-medium -me-1">C</span>
          <span className="letter panoragraf-regular font-medium">A</span>
          <span className="letter panoragraf-regular font-medium">R</span>
          <span className="letter panoragraf-regular font-medium">E</span>
        </div>
      </div>
      <p
        className="mb-12 text-white panoragraf-light uppercase slide-in-from-top"
        style={{ fontSize: paragraphSize }} // Apply dynamic font size
      >
        fisio & sportclinic
      </p>
    </>
  );
}

export default LogoAnimation;
